import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '@loggi/ui/components/text-input';
import { SIZES } from './types';

const INPUT_TYPE = 'search';

export default class InputWrapper extends React.Component {
  static propTypes = {
    statusText: PropTypes.string,
    status: PropTypes.string,
    label: PropTypes.string,
    size: PropTypes.oneOf(SIZES),
    hasFocus: PropTypes.bool,
    onSuggestionsOpen: PropTypes.func,
    onSuggestionsClose: PropTypes.func,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    displayIcon: PropTypes.bool,
    displayStatus: PropTypes.bool,
    disableBorder: PropTypes.bool,
    inverse: PropTypes.bool
  };

  static defaultProps = {
    disabled: false
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const prop = 'aria-expanded';
    if (nextProps[prop] !== this.props[prop]) {
      if (nextProps[prop] && this.props.onSuggestionsOpen) {
        this.props.onSuggestionsOpen();
      } else if (this.props.onSuggestionsClose) {
        this.props.onSuggestionsClose();
      }
    }
  }

  /*
   *
   * some props is not used, but we get  them from props
   * to avoid unknown prop error
   * https://reactjs.org/warnings/unknown-prop.html
   */
  render() {
    const {
      status,
      statusText,
      disabled,
      label,
      size,
      hasFocus,
      icon,
      displayIcon,
      displayStatus,
      disableBorder,
      inverse,
      onSuggestionsOpen,
      onSuggestionsClose,
      statusInfo,
      ...otherProps
    } = this.props;

    return (
      <TextInput
        icon={icon}
        inputProps={otherProps}
        label={label}
        status={status}
        statusText={statusText}
        displayStatus={displayStatus}
        displayIcon={displayIcon}
        size={size}
        disabled={disabled}
        hasFocus={hasFocus}
        inverse={inverse}
        disableBorder={disableBorder}
        type={INPUT_TYPE}
      />
    );
  }
}
